import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User paused a video',
  name: 'paused_video',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
